// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"348c88d7","157":"7ead2dc1","249":"46cf248e","269":"a4990d42","553":"5b1265e6","991":"194831fa"}[chunkId] + ".chunk.js";
};